import * as React from "react";

import { DIAGNOSIS_STEP_CHIP_LABELS } from "./diagnosisFlowStepDefinitions";
import { DiagnosisStepChip, DiagnosisStepChipsRow } from "./DiagnosisStepChip";

interface DiagnosisStyleStepChipsProps {
  // 投資スタイル診断の完了直後の画面ではアクティブチップに✓を付ける
  isCompleted: boolean;
}

// 投資スタイル診断フェーズ共通のステップ表示（2番目の名前は結果の呼び方にそろえて「投資方針書」）
export const DiagnosisStyleStepChips: React.FC<DiagnosisStyleStepChipsProps> = ({ isCompleted }) => (
  <DiagnosisStepChipsRow>
    <DiagnosisStepChip v2 label={DIAGNOSIS_STEP_CHIP_LABELS.investment} state="completed" withCheck={true} />
    <DiagnosisStepChip animate v2 label={DIAGNOSIS_STEP_CHIP_LABELS.style} state="active" withCheck={isCompleted} />
    <DiagnosisStepChip v2 label={DIAGNOSIS_STEP_CHIP_LABELS.planner} state="upcoming" withCheck={false} />
  </DiagnosisStepChipsRow>
);
